import errorHandler from '@/utils/helpers/errorHandler';
import { Notification } from '@/utils/helpers/notification';
import { checkinApi } from '@/services/api/httpClient';

const actions = {
  async dataProviderGetUnits({ commit }, params) {
    commit('enableLoader', true);
    const endpoint = `/unit/data-provider?brandId=${params.idMarca}`;

    try {
      const request = await checkinApi().get(endpoint);
      const { data } = request;
      if (!data) {
        throw data;
      }
      const units = data || null;

      commit('SET_UNITS_LIST', units);
      return units;
    } catch (err) {
      Notification.error({ duration: 6000 });
      errorHandler(err);
      throw err;
    } finally {
      commit('enableLoader', false);
    }
  },

  async getUnitConfigs({ commit }, unitId) {
    const endpoint = `/unit/${unitId}`;

    try {
      const request = await checkinApi().get(endpoint);
      const { data } = request;
      commit('SET_UNIT_CONFIGS', data);
      return data;
    } catch (err) {
      console.error(`> unitConfigsByUnitManager ERROR: ${err}`);
    }
  },

  async unitConfigGetUnits({ commit }, params) {
    const { brandId, collaboratorCampaign } = params;
    const endpoint = `/unit?brandId=${brandId}&collaboratorCampaign=${collaboratorCampaign}`;

    try {
      commit('enableLoader', true);

      const request = await checkinApi().get(endpoint);
      const { data } = request;

      commit('SET_UNITS_LIST', data);
      commit('enableLoader', false);

      return data;
    } catch (err) {
      commit('enableLoader', false);
      console.error('Erro ao recuperar a lista de unidades');
      Notification.error({ duration: 6000 });
      errorHandler(err);
    }
  },
};

export default actions;
